import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TH_SARABUN_TTF_BASE64 } from "@/assets/fonts/thsarabun.js";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      busy: false,
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      apiStatus: "กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล",
      fields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "delivery_document.document_date",
          label: "วันที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "delivery_document.document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "delivery_document.bill_customer_name",
          label: "ชื่อลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "code",
          label: "รหัสสินค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "code_description",
          label: "รายละเอียดสินค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "total_length",
          label: "จำนวน",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-black td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "unit_price",
          label: "ราคา/หน่วย",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-black td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "total_price",
          label: "ยอดขาย ฿",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "font-weight-bold text-black td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      items: [],
      form: {
        keyword: null,
        sale_id: null,
        start_date: new Date(moment().startOf("month").format("YYYY-MM-DD")),
        end_date: new Date(moment().endOf("month").format("YYYY-MM-DD")),
      },
      seller_list: [],
      sum: 0,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    parseReportDate(dateValue) {
      if (!dateValue) return null;
      if (dateValue instanceof Date) return dateValue;

      const value = String(dateValue);
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split("-").map(Number);
        return new Date(year, month - 1, day);
      }

      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    formatThaiDate(dateValue, options = {}) {
      const parsed = this.parseReportDate(dateValue);
      if (!parsed) return "-";
      return parsed.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
        ...options,
      });
    },
    async onInitData() {
      try {
        const item = this.items;
        this.items = [];
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const res = await this.$axios.get(
          this.$host +
            "/api/v1/report/sale-history?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD") +
            "&keyword=" +
            (this.form.keyword != null ? this.form.keyword : "")
        );

        const data = res.data;

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.items = data.data;
        this.sum = data.total;
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onLoadEmployee() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host + "/api/v1/document/quotation/branch/employee"
        );

        const newObj = { name: "--- ทั้งหมด ---", id: null };
        this.seller_list = res.data;

        this.seller_list.unshift(newObj);

        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    exportPDFReport() {
      this.loading = true;
      setTimeout(async () => {
        this.loading = true;

        const result = await this.$axios.get(
          this.$host +
            "/api/v1/report/pdf/sku?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD"),

          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        if (isSafari) {
          window.open(objectUrl);
          // const link = document.createElement('a')
          // link.href = objectUrl2
          // link.setAttribute('download', 'ใบเสนอราคา ' +  + '.pdf')
          // document.body.appendChild(link)
          // link.click()

          this.loading = false;
        } else {
          window.open(
            objectUrl,
            "targetWindow",
            `toolbar=no,
           location=no,
           status=no,
           menubar=no,
           scrollbars=yes,
           resizable=yes,
           width=SomeSize,
           height=SomeSize`
          );
          this.loading = false;
        }
        // URL.revokeObjectURL(objectUrl);
      }, 1000);
    },
    // ---------- ตัวช่วยฟอนต์ไทย (ถ้ามี) ----------
    addThaiFont(doc) {
      if (!doc || !TH_SARABUN_TTF_BASE64) return;
      doc.addFileToVFS("THSarabun.ttf", TH_SARABUN_TTF_BASE64);
      doc.addFont("THSarabun.ttf", "THSarabun", "normal");
      doc.addFont("THSarabun.ttf", "THSarabun", "bold");
    },

    // ---------- Export PDF (A4 landscape, พอดีหน้า) ----------
    exportPagePDF() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export PDF",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });
      // ถ้ามีฟอนต์ไทย: เปิดสองบรรทัดนี้
      this.addThaiFont?.(doc);
      doc.setFont?.("THSarabun", "normal");

      // margin + header/footer
      const margin = { top: 80, right: 36, bottom: 48, left: 36 };
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();

      const title = "ประวัติการขาย";
      const period = `ช่วงวันที่: ${moment(this.form.start_date).format(
        "DD/MM/YYYY"
      )} - ${moment(this.form.end_date).format("DD/MM/YYYY")}`;

      const drawHeader = () => {
        doc.setFontSize(18);
        doc.setFont?.("THSarabun", "bold");
        doc.text(title, margin.left, 40);
        doc.setFontSize(12);
        doc.setFont?.("THSarabun", "normal");
        doc.text(period, margin.left, 60);
      };
      const drawFooter = (pageNo) => {
        doc.setFontSize(11);
        doc.text(`หน้า ${pageNo}`, pageW - margin.right, pageH - 20, {
          align: "right",
        });
      };

      let pageNo = 1;
      drawHeader();
      drawFooter(pageNo);

      // columns (พอดีพื้นที่ A4 หลังหัก margin: รวม = 720pt)
      const head = [
        [
          "#", // 0: 24
          "วันที่เอกสาร", // 1: 68
          "เลขที่เอกสาร", // 2: 80
          "ชื่อลูกค้า", // 3: 130
          "รหัสสินค้า", // 4: 80
          "รายละเอียดสินค้า", // 5: 140
          "จำนวน", // 6: 60
          "ราคา/หน่วย", // 7: 68
          "ยอดขาย ฿", // 8: 72
        ],
      ];

      const col = {
        0: { cellWidth: 24, halign: "right" },
        1: { cellWidth: 68 },
        2: { cellWidth: 80 },
        3: { cellWidth: 130 },
        4: { cellWidth: 80 },
        5: { cellWidth: 140 },
        6: { cellWidth: 60, halign: "right" },
        7: { cellWidth: 68, halign: "right" },
        8: { cellWidth: 72, halign: "right" },
      };

      const fmtDate = (d) =>
        this.formatThaiDate(d, { month: "2-digit", day: "2-digit" });
      const money = (n) =>
        parseFloat(n || 0).toLocaleString("th-TH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      const qty = (n) =>
        parseFloat(n || 0).toLocaleString("th-TH", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });

      // map items -> rows
      const body = this.items.map((it, idx) => [
        idx + 1,
        fmtDate(it?.delivery_document?.document_date),
        it?.delivery_document?.document_no || "-",
        (() => {
          const n = it?.delivery_document?.customer?.name || "-";
          const c = it?.delivery_document?.customer?.company_name || "";
          return c && c !== "-" ? `${n}\n${c}` : n; // ขึ้นบรรทัดใหม่ให้ไม่ล้น
        })(),
        it?.code || "-",
        it?.code_description || "-",
        qty(it?.total_quantity ?? it?.total_length),
        money(it?.unit_price),
        money(it?.total_price),
      ]);

      // ตารางหลัก
      doc.autoTable({
        startY: margin.top,
        head,
        body,
        margin,
        pageBreak: "auto",
        tableWidth: "wrap",
        styles: {
          font: "THSarabun", // ถ้าไม่ฝังฟอนต์ ออปชั่นนี้จะถูกเมิน
          fontSize: 10,
          cellPadding: 3,
          overflow: "linebreak", // ตัดบรรทัดอัตโนมัติ
          lineColor: [220, 220, 220],
          lineWidth: 0.2,
          valign: "middle",
        },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: 20,
          halign: "center",
        },
        columnStyles: col,
        didDrawPage: (data) => {
          if (data.pageNumber > pageNo) {
            pageNo = data.pageNumber;
            drawHeader();
            drawFooter(pageNo);
          }
        },
      });

      // แถวสรุปท้าย (Grand Total จาก this.sum ถ้ามี)
      const grand =
        this.sum ||
        this.items.reduce((acc, it) => acc + (+it.total_price || 0), 0);
      doc.autoTable({
        startY: (doc.lastAutoTable ? doc.lastAutoTable.finalY : margin.top) + 6,
        theme: "plain",
        margin,
        styles: { font: "THSarabun", fontSize: 12, cellPadding: 6 },
        columnStyles: col,
        body: [["", "", "", "", "", "", "", "ยอดรวมทั้งหมด", money(grand)]],
      });

      // save
      const fn = `ประวัติการขาย_${new Date().toLocaleDateString("th-TH")}.pdf`;
      doc.save(fn);
    },

    // ---------- Export Excel (จากข้อมูลบนหน้า) ----------
    exportPageExcel() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export Excel",
          variant: "warning",
          solid: true,
        });
        return;
      }

      // flatten rows ให้เหมือนคอลัมน์ในตารางหน้าเว็บ
      const rows = this.items.map((it, i) => ({
        "#": i + 1,
        วันที่เอกสาร: this.parseReportDate(it?.delivery_document?.document_date),
        เลขที่เอกสาร: it?.delivery_document?.document_no || "-",
        ชื่อลูกค้า: it?.delivery_document?.customer?.name || "-",
        บริษัท: it?.delivery_document?.customer?.company_name || "-",
        รหัสสินค้า: it?.code || "-",
        รายละเอียดสินค้า: it?.code_description || "-",
        จำนวน: +parseFloat(it?.total_quantity ?? it?.total_length ?? 0),
        "ราคา/หน่วย": +parseFloat(it?.unit_price ?? 0),
        "ยอดขาย ฿": +parseFloat(it?.total_price ?? 0),
      }));

      const ws = XLSX.utils.json_to_sheet(rows, { cellDates: true });
      // ความกว้างคอลัมน์ (ปรับให้พอดีกับหน้า)
      ws["!cols"] = [
        { wch: 4 }, // #
        { wch: 12 }, // วันที่เอกสาร
        { wch: 16 }, // เลขที่เอกสาร
        { wch: 22 }, // ชื่อลูกค้า
        { wch: 22 }, // บริษัท
        { wch: 14 }, // รหัสสินค้า
        { wch: 28 }, // รายละเอียดสินค้า
        { wch: 10 }, // จำนวน
        { wch: 12 }, // ราคา/หน่วย
        { wch: 14 }, // ยอดขาย ฿
      ];

      // ฟอร์แมตเซลล์วันที่และตัวเลข
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        const d = XLSX.utils.encode_cell({ r: R, c: 1 }); // วันที่เอกสาร
        const q = XLSX.utils.encode_cell({ r: R, c: 7 }); // จำนวน
        const u = XLSX.utils.encode_cell({ r: R, c: 8 }); // ราคา/หน่วย
        const t = XLSX.utils.encode_cell({ r: R, c: 9 }); // ยอดขาย
        if (ws[d]) ws[d].z = "dd/mm/yyyy";
        if (ws[q]) ws[q].z = "#,##0.##";
        if (ws[u]) ws[u].z = "#,##0.00";
        if (ws[t]) ws[t].z = "#,##0.00";
      }

      // แถวสรุปรวมท้ายชีต
      const lastRow = range.e.r + 2;
      const sumLabelCell = XLSX.utils.encode_cell({ r: lastRow - 1, c: 8 });
      const sumValCell = XLSX.utils.encode_cell({ r: lastRow - 1, c: 9 });
      ws[sumLabelCell] = { t: "s", v: "ยอดรวมทั้งหมด" };
      ws[sumValCell] = {
        t: "n",
        v: +this.sum || rows.reduce((a, r) => a + (r["ยอดขาย ฿"] || 0), 0),
        z: "#,##0.00",
      };

      // AutoFilter
      ws["!autofilter"] = { ref: ws["!ref"] };

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการขาย");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fn = `ประวัติการขาย_${new Date().toLocaleDateString("th-TH")}.xlsx`;
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fn);
    },
  },
  async mounted() {
    await this.onLoadEmployee();
  },
};
